import script from "./InstructionRoAppPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionRoAppPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionRoAppPage.vue?vue&type=style&index=0&id=788f49c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-788f49c2"]])

export default __exports__